import Cookies from "js-cookie";

// state
export const state = {
  deliveryMethod: Cookies.get("delivery-method")
    ? Cookies.get("delivery-method")
    : "",
  deliveryPrice: Cookies.get("delivery-price")
    ? Cookies.get("delivery-price")
    : "",
  deliveryDistance: Cookies.get("delivery-distance")
    ? Cookies.get("delivery-distance")
    : "",
  deliveryTime: Cookies.get("delivery-time")
    ? parseInt(Cookies.get("delivery-time"))
    : "",
  estimatedTime: Cookies.get("delivery-estimated-time")
    ? parseInt(Cookies.get("delivery-estimated-time"))
    : "",
  isAsap: null,
  dropoffDateTime: null,
  non_deliverable_reason: Cookies.get("non_deliverable_reason") ?? null,
  non_deliverable_error: Cookies.get("non_deliverable_error") ?? null,
  optionDoor: false,
};

// mutations
export const mutations = {
  SET_DELIVERY_METHOD: (state, data) => {
    Cookies.set("delivery-method", data, { expires: 365 });
    state.deliveryMethod = data;
  },
  REMOVE_DELIVERY_METHOD: () => {
    Cookies.remove("delivery-method");
    state.deliveryMethod = 0;
  },
  SET_DELIVERY_ADDRESS_CHECK_DETAILS: (state, data) => {
    Cookies.set("non_deliverable_reason", data.non_deliverable_reason, {
      expires: 365,
    });
    Cookies.set("non_deliverable_error", data.non_deliverable_error, {
      expires: 365,
    });
    state.non_deliverable_error = data.non_deliverable_error;
    state.non_deliverable_reason = data.non_deliverable_reason;
  },
  SET_DELIVERY_DETAILS: (state, data) => {
    Cookies.set("delivery-price", data.price, { expires: 365 });
    Cookies.set("delivery-distance", data.distance, { expires: 365 });
    Cookies.set("delivery-time", data.time, { expires: 365 });
    Cookies.set("delivery-estimated-time", data.estimatedTime, {
      expires: 365,
    });
    state.deliveryPrice = data.price;
    state.deliveryDistance = data.distance;
    state.deliveryTime = data.time;
    state.estimatedTime = data.estimatedTime;
  },
  REMOVE_DELIVERY_DETAILS: () => {
    Cookies.remove("delivery-price");
    state.deliveryPrice = "";
    Cookies.remove("delivery-distance");
    state.deliveryDistance = "";
    Cookies.remove("delivery-time");
    Cookies.remove("delivery-estimated-time");
    state.deliveryTime = "";
    state.estimatedTime = undefined;
  },
  REMOVE_ADDRESS_CHECK_DETAILS: () => {
    Cookies.remove("non_deliverable_reason");
    Cookies.remove("non_deliverable_error");
    state.non_deliverable_error = undefined;
    state.non_deliverable_reason = undefined;
  },
  SET_IS_ASAP: (state, data) => {
    state.isAsap = data;
  },
  SET_DROPPOFF_DATE_TIME: (state, data) => {
    state.dropoffDateTime = data;
  },
  SET_DELIVERY_TIME: (state, data) => {
    state.deliveryTime = data;
  },
  SET_ESTIMATED_TIME: (state, data) => {
    state.estimatedTime = data;
  },
  SET_OPTION_DOOR: (state, data) => {
    state.optionDoor = data;
  },
  RESET_ALL: (state) => {
    //TODO:check when I use this
    /*  Cookies.remove("delivery-method");
    state.deliveryMethod = ""; */
    Cookies.remove("delivery-price");
    state.deliveryPrice = "";
    Cookies.remove("delivery-distance");
    state.deliveryDistance = "";
    Cookies.remove("delivery-time");
    Cookies.remove("delivery-estimated-time");
    Cookies.remove("non_deliverable_reason");
    Cookies.remove("non_deliverable_error");
    state.deliveryTime = "";
    // state.isAsap = null;
    state.dropoffDateTime = null;
    state.optionDoor = false;
    state.estimatedTime = undefined;
    state.non_deliverable_error = undefined;
    state.non_deliverable_reason = undefined;
  },
};

// actions
export const actions = {
  setDeliveryMethod({ commit }, payload) {
    commit("SET_DELIVERY_METHOD", payload);
  },
  removeDeliveryMethod({ commit }) {
    commit("REMOVE_DELIVERY_METHOD");
  },
  setDeliveryDetails({ commit }, payload) {
    commit("SET_DELIVERY_DETAILS", payload);
  },
  setDeliveryAddressCheckDetails({ commit }, payload) {
    commit("SET_DELIVERY_ADDRESS_CHECK_DETAILS", payload);
  },
  removeDeliveryDetails({ commit }) {
    commit("REMOVE_DELIVERY_DETAILS");
  },
  removeDeliveryAddressCheckDetails({ commit }) {
    commit("REMOVE_ADDRESS_CHECK_DETAILS");
  },
  setIsAsap({ commit }, payload) {
    commit("SET_IS_ASAP", payload);
  },
  setDropoffDateTime({ commit }, payload) {
    commit("SET_DROPPOFF_DATE_TIME", payload);
  },
  setDeliveryTime({ commit }, payload) {
    commit("SET_DELIVERY_TIME", payload);
  },
  setEstimatedTime({ commit }, payload) {
    commit("SET_ESTIMATED_TIME", payload);
  },
  setOptionDoor({ commit }, payload) {
    commit("SET_OPTION_DOOR", payload);
  },
  resetAll({ commit }) {
    commit("RESET_ALL");
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
